import * as types from './actionTypes';
import {api} from './api';

export function updateNewPolicy(policy) {
  return { type: types.POLICY__UPDATE_NEW_POLICY, policy };
}

export function clearNewPolicy() {
  return { type: types.POLICY__CLEAR_NEW_POLICY };
}

export function removePolicy(policy) {
    return api({
        types: [types.POLICY__REMOVE_REQUEST, types.POLICY__REMOVE_SUCCESS, types.POLICY__REMOVE_FAILURE],
        uri: '/api/policy',
        config: {
            method: 'delete',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( policy )
        },
        payload: { policy }
    });
}

export function getPolicies(policies) {
    return api({
        types: [types.POLICY__GET_REQUEST, types.POLICY__GET_SUCCESS, types.POLICY__GET_FAILURE],
        uri: '/api/policy',
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( { policies } )
        },
        payload: { policies }
    });
}

export function getOnetimePolicies(policies, accountNumber) {
    return api({
        types: [types.POLICY__GET_ONETIME_REQUEST, types.POLICY__GET_ONETIME_SUCCESS, types.POLICY__GET_ONETIME_FAILURE],
        uri: '/api/policy/onetime',
        sendJwtBearer: false,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( { accountNumber, policies } )
        },
        payload: { policies }
    });
}

export function addPolicy(policy) {
    return api({
        types: [types.POLICY__ADD_REQUEST, types.POLICY__ADD_SUCCESS, types.POLICY__ADD_FAILURE],
        uri: '/api/policy/add',
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( policy )
        },
        payload: { policy }
    });
}

export function updatePolicy(policy) {
    return api({
        types: [types.POLICY__EDIT_NICKNAME_REQUEST, types.POLICY__EDIT_NICKNAME_SUCCESS, types.POLICY__EDIT_NICKNAME_FAILURE],
        uri: '/api/policy/edit',
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( policy )
        },
        payload: { policy }
    });
}

export function save(data) {
    const body = {
        ...data
    };

    return api({
        types: [types.POLICYSAVE__REQUEST, types.POLICYSAVE__SUCCESS, types.POLICYSAVE__FAILURE],
        uri: `/api/policysave/${data.policyNumber}`,
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function getSave(policyNumber) {
    return api({
        types: [types.POLICYSAVE__GET_REQUEST, types.POLICYSAVE__GET_SUCCESS, types.POLICYSAVE__GET_FAILURE],
        uri: `/api/policysave/${policyNumber}`,
        shouldCallAPI: () => true,
        config: {
            method: 'get',
            headers: {
               'Content-Type': 'application/json'
            }
        }
    });
}

export function deleteSave(policyNumber) {
    return api({
        types: [types.POLICYSAVE__DELETE_REQUEST, types.POLICYSAVE__DELETE_SUCCESS, types.POLICYSAVE__DELETE_FAILURE],
        uri: `/api/policysave/${policyNumber}/delete`,
        shouldCallAPI: () => true,
        config: {
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    })
}

export function rateDriver(body) {
    return api({
        types: [types.POLICYRATE__DRIVER_REQUEST, types.POLICYRATE__DRIVER_SUCCESS, types.POLICYRATE__DRIVER_FAILURE],
        uri: `/api/policyupdate/rate/driver`,
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function rateVehicle(body) {
    return api({
        types: [types.POLICYRATE__VEHICLE_REQUEST, types.POLICYRATE__VEHICLE_SUCCESS, types.POLICYRATE__VEHICLE_FAILURE],
        uri: `/api/policyupdate/rate/vehicle`,
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function rateCreditor(body) {
    return api({
        types: [types.POLICYRATE__CREDITOR_REQUEST, types.POLICYRATE__CREDITOR_SUCCESS, types.POLICYRATE__CREDITOR_FAILURE],
        uri: `/api/policyupdate/rate/creditor`,
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}


export function rateDeleteDriver(body) {
    return api({
        types: [types.POLICYRATE__DELETE_DRIVER_REQUEST, types.POLICYRATE__DELETE_DRIVER_SUCCESS, types.POLICYRATE__DELETE_DRIVER_FAILURE],
        uri: '/api/policyupdate/rate/driver/delete',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function rateDeleteCreditor(body) {
    return api({
        types: [types.POLICYRATE__DELETE_CREDITOR_REQUEST, types.POLICYRATE__DELETE_CREDITOR_SUCCESS, types.POLICYRATE__DELETE_CREDITOR_FAILURE],
        uri: '/api/policyupdate/rate/creditor/delete',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function deleteRate(body) {
    return api({
        types: [types.POLICYRATE__DELETE_REQUEST, types.POLICYRATE__DELETE_SUCCESS, types.POLICYRATE__DELETE_FAILURE],
        uri: '/api/policyupdate/rate/delete',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function rateDeleteVehicle(body) {
    return api({
        types: [types.POLICYRATE__DELETE_VEHICLE_REQUEST, types.POLICYRATE__DELETE_VEHICLE_SUCCESS, types.POLICYRATE__DELETE_VEHICLE_FAILURE],
        uri: '/api/policyupdate/rate/vehicle/delete',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function rateConfirm(body) {
    return api({
        types: [types.POLICYRATE__CONFIRM_REQUEST, types.POLICYRATE__CONFIRM_SUCCESS, types.POLICYRATE__CONFIRM_FAILURE],
        uri: '/api/policyupdate/rate/confirm',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}

export function sendErrorEmail(body) {
    return api({
        types: [types.POLICYRATE__SENDERROREMAIL_REQUEST, types.POLICYRATE__SENDERROREMAIL_SUCCESS, types.POLICYRATE__SENDERROREMAIL_FAILURE],
        uri: '/api/policyupdate/senderroremail',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
            },
            body: JSON.stringify( body )
        },
        payload: { body }
    });
}